module.exports = __webpack_public_path__ + "img/1565047124.1e49ddd7.jpg";